import axios from "axios";
import store from "../store/store";
import { pageMessages } from "../constants/MessageConstants";

export async function getRequest(authRequired, url, params){
    const paramString= params&&Object.keys(params).map((key) => {return `${key}=${params[key]}`}).join("&");
    const header= getHeader(authRequired);
    try{
        if(header){
            const response= await axios.get(paramString?url+"?"+paramString:url, header);
            if(response.data.status===200 || response.data.status===201){
                return { status: response.data.status, isError: false, data: response.data.data, message: response.data.message};
            }else if ((response.data.status===412 || response.data.status===401)){
                store.dispatch({type: 'LOGOUT'});
                return { status: response.data.status, isError: true, message: pageMessages.tokenExpired};
            }else{
                return { status: response.data.status, isError: true, message: response.data.message};
            }
        }else{
            return { status: 401, isError: true, message: pageMessages.noToken}
        }
    }catch(err){
        return { status: 500, isError: true, message: pageMessages.unknownError}
    }    
}
export async function deleteRequest(authRequired, url, params){
    const paramString= params&&Object.keys(params).map((key) => {return `${key}=${params[key]}`}).join("&");
    const header= getHeader(authRequired);
    try{
        if(header){
            const response= await axios.delete(paramString?url+"?"+paramString:url, header);
            if(response.data.status===200 || response.data.status===201){
                return { status: response.data.status, isError: false, data: response.data.data, message: response.data.message};
            }else if ((response.data.status===412 || response.data.status===401)){
                store.dispatch({type: 'LOGOUT'});
                return { status: response.data.status, isError: true, message: pageMessages.tokenExpired};
            }else{
                return { status: response.data.status, isError: true, message: response.data.message};
            }
        }else{
            return { status: 401, isError: true, message: pageMessages.noToken}
        }
    }catch(err){
        return { status: 500, isError: true, message: pageMessages.unknownError}
    }    
}
export async function putRequest(authRequired, url, request){
    const header= getHeader(authRequired);
    try{
        if(header){
            const response= await axios.put(url, request, header);
            if(response.data.status===200 || response.data.status===201){
                return { status: response.data.status, isError: false, data: response.data.data, message: response.data.message};
            }else if ((response.data.status===412 || response.data.status===401)){
                store.dispatch({type: 'LOGOUT'});
                return { status: response.data.status, isError: true, message: pageMessages.tokenExpired};
            }else{
                return { status: response.data.status, isError: true, message: response.data.message};
            }
        }else{
            return { status: 401, isError: true, message: pageMessages.noToken}
        }
    }catch(err){
        return { status: 500, isError: true, message: pageMessages.unknownError}
    }    
}
export async function postRequest(authRequired, url, request){
    const header= getHeader(authRequired);
    try{
        if(header){
            const response= await axios.post(url, request, header);
            if(response.data.status===200 || response.data.status===201){
                return { status: response.data.status, isError: false, data: response.data.data, message: response.data.message};
            }else if ((response.data.status===412 || response.data.status===401)){
                store.dispatch({type: 'LOGOUT'});
                return { status: response.data.status, isError: true, message: pageMessages.tokenExpired};
            }else{
                return { status: response.data.status, isError: true, message: response.data.message};
            }
        }else{
            return { status: 401, isError: true, message: pageMessages.noToken}
        }
    }catch(err){
        return { status: 500, isError: true, message: pageMessages.unknownError}
    }    
}
function getHeader(authRequired){
    const { user } = store.getState();
    if(authRequired){
        if(user && user.user && user.user.accessToken){
            return {
                headers: {
                  Authorization: "Bearer " + user.user.accessToken,
                },
            }
        }else{
            return null
        } 
    }else{
        return {}
    }
}